import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IMaskModule } from 'angular-imask';
import { PessoaModule, SharedModule } from 'eddydata-lib';
import { AccordionModule } from 'primeng/accordion';
import { MessageService } from 'primeng/api';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { CalendarModule } from 'primeng/calendar';
import { DialogModule } from 'primeng/dialog';
import { FileUploadModule } from 'primeng/fileupload';
import { InputMaskModule } from 'primeng/inputmask';
import { PanelModule } from 'primeng/panel';
import { RadioButtonModule } from 'primeng/radiobutton';
import { ToastModule } from 'primeng/toast';
import { LicitacaoAudespMenuModule } from '../licitacao-audesp-menu/licitacao-audesp-menu.module';
import { ContratoAditamentoDlgComponent } from './contrato-aditamento-dlg/contrato-aditamento-dlg.component';
import { ContratoAditamentoComponent } from './contrato-aditamento/contrato-aditamento.component';
import { ContratoFormComponent } from './contrato-form/contrato-form.component';
import { ContratoHistoricoDlgComponent } from './contrato-historico-dlg/contrato-historico-dlg.component';
import { ContratoHistoricoComponent } from './contrato-historico/contrato-historico.component';
import { ContratoListComponent } from './contrato-list/contrato-list.component';
import { ContratoPagamentoComponent } from './contrato-pagamento/contrato-pagamento.component';
import { ContratoReajusteDlgComponent } from './contrato-reajuste-dlg/contrato-reajuste-dlg.component';
import { ContratoReajusteComponent } from './contrato-reajuste/contrato-reajuste.component';
import { ContratoResponsavelComponent } from './contrato-responsavel/contrato-responsavel.component';
import { ContratoRoutingModule } from './contrato-routing.module';
import { ContratoRptComponent } from './contrato-rpt/contrato-rpt.component';
import { ContratoViewComponent } from './contrato-view/contrato-view.component';

@NgModule({
  declarations: [
    ContratoListComponent,
    ContratoViewComponent,
    ContratoFormComponent,
    ContratoRptComponent,
    ContratoPagamentoComponent,
    ContratoAditamentoComponent,
    ContratoAditamentoDlgComponent,
    ContratoResponsavelComponent,
    ContratoHistoricoComponent,
    ContratoHistoricoDlgComponent,
    ContratoReajusteComponent,
    ContratoReajusteDlgComponent,
  ],
  imports: [
    CommonModule,
    ContratoRoutingModule,
    SharedModule,
    FormsModule,
    AutoCompleteModule,
    AccordionModule,
    CalendarModule,
    IMaskModule,
    ToastModule,
    InputMaskModule,
    RadioButtonModule,
    FileUploadModule,
    PanelModule,
    PessoaModule,
    LicitacaoAudespMenuModule,
    DialogModule
  ],
  providers: [MessageService]
})
export class ContratoModule { }
